var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import * as Mamba from '@mamba/clients';
import localforage from 'localforage';
import lodash from 'lodash';
import { BindAll } from 'lodash-decorators';
import { action } from 'mobx';
import moment from 'moment';
import Vue from 'vue';
import { UserAgent } from './userAgent';
// 持久化访问器
const LocalForage = localforage.createInstance({
    // driver: localforage.LOCALSTORAGE, // Forc
    name: process.env.StorageKey,
    storeName: process.env.StorageKey,
});
Mamba.BasesOptions.resetConfig({
    // storagePrefix: process.env.StorageKey,
    createStorage: lodash.constant({
        clear: LocalForage.clear,
        setItem: LocalForage.setItem,
        removeItem: LocalForage.removeItem,
        getItem: LocalForage.getItem,
    }),
});
// const Hydrate = Mamba.BasesOptions.createHydrate();
const AppSettingsDetault = {
    language: 'zh',
    formType: 'drawer',
    theme: 'light',
    // navTheme: 'light', // theme for nav menu
    // primaryColor: '#52C41A', // primary color of ant design
    // layout: 'topmenu', // nav menu position: `sidemenu` or `topmenu`
    // contentWidth: 'Fluid', // layout of content: `Fluid` or `Fixed`, only works when layout is topmenu
    fixedHeader: true,
    fixSiderbar: true,
    // colorWeak: false,
    // menu: {
    //     locale: true
    // },
    title: '大联想伙伴网直播间',
    // pwa: false,
    // iconfontUrl: '',
    // production: false
};
let AppConfig = class AppConfig extends Mamba.ClientsEnv {
    constructor() {
        super(...arguments);
        // @persist('object')
        // @observable
        this.AppSettings = lodash.cloneDeep(AppSettingsDetault);
        /**
         * 账号中心存储key值
         * @memberof AppConfig
         */
        this.accountKey = '_account__user';
        this.userKey = '_app_user';
        /**
         * 环境设备信息
         * @memberof AppConfig
         */
        this.userAgent = new UserAgent();
        /**
         * __MICRO_APP_ENVIRONMENT__
         * @memberof AppConfig
         */
        this.MICRO = window.__MICRO_APP_ENVIRONMENT__;
    }
    /**
     * 判断是否被 嵌套成子页面
     * @readonly
     * @memberof AppConfig
     */
    get ChildrenPage() {
        return window.self !== window.top || this.MICRO;
    }
    /**
     * 更改配置
     * @param config
     */
    onChangeAppSettings(event) {
        lodash.set(this.AppSettings, event.type, event.value);
        this.onChangeLanguage();
    }
    /**
     * 更改语言
     * @param config
     */
    onChangeLanguage() {
        // Vue.onChangeLanguage(this.AppSettings.language)
        moment.locale(lodash.get({ en: 'en', zh: 'zh-cn' }, this.AppSettings.language));
    }
    /**
     * 清理缓存
     * @memberof ClientsEnv
     */
    async onClear() {
        const versionKey = this.createStorageKey('version');
        const versionVal = lodash.join([this.version, this.timestamp], '-');
        await LocalForage.clear();
        await LocalForage.setItem(versionKey, versionVal);
        return true;
    }
};
__decorate([
    action.bound
], AppConfig.prototype, "onChangeAppSettings", null);
AppConfig = __decorate([
    BindAll()
], AppConfig);
export const $AppConfig = new AppConfig();
if (!$AppConfig.MICRO) {
    $AppConfig.onInspectVersion();
}
lodash.set(Vue, 'AppConfig', $AppConfig);
Object.defineProperty(Vue.prototype, 'AppConfig', {
    get: lodash.constant($AppConfig),
});
